import React from 'react';
import { CTA_TYPES, STANDARD_EVENTS } from 'utils/analytics/trackV2';

export default class ExternalLink extends React.Component {
  handleClick = (e) => {
    const { handleTrack, children } = this.props;
    if (!handleTrack) return;
    handleTrack({
      event: STANDARD_EVENTS.click,
      params: {
        label:
          (typeof children === 'string' ? children : e.target.textContent) ||
          '',
        cta_type: CTA_TYPES.link,
        destination_url: e.currentTarget.href,
      },
    });
  };

  render() {
    return (
      <a
        onClick={this.handleClick}
        target="_blank"
        rel="external noopener noreferrer"
        {...this.props}>
        {this.props.children || this.props.href}
      </a>
    );
  }
}
